import ApiInvoker from 'apis/services/apiInvoker';
import MgtvApi from 'MgtvApi';
import DataStorage from './dataStore';
import { aesEncrypt } from './encrypt';
import Env from './env';
import { getCookie, guid } from './index';
import { getMgtvUserTicket } from './user';
import store from '@/store';


export function initBaiduMonitor() {
  if (process.env.VUE_APP_ENV === 'production') {
    (function () {
      const hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?9446cbb8ead7b1fdad367d8d8d235c06';
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(hm, s);
    }());
  }
}

export function uploadRequest(conditions) {
  if (Env.isLocal) {
    return;
  }
  const url = process.env.VUE_APP_UPLOAD_API; // 电商上报地址
  return ApiInvoker.loadByImg(url, conditions, Env.isMgtvApp);
}

export function getUid() {
  return new Promise((resolve) => {
    if (Env.isMgtvApp) {
      MgtvApi.getDeviceInfo((data) => {
        const { did, idfa, imei } = JSON.parse(data);
        resolve({
          did,
          idfa,
          imei,
        });
      });
      setTimeout(() => {
        resolve({
          did: '',
          idfa: '',
          imei: '',
        });
      }, 150);
    } else {
      resolve({
        did: getCookie('PHPSESSID_MGTV'),
      });
    }
  });
}


/* 存储上报需要的固定值参数 (透传下去的数据)  */
export async function setFixedParams(origin) {
  const nowPageName = DataStorage.getNowPage();
  const lastPageName = DataStorage.getPrePage();
  const originPage = ['goods_detail', 'home', 'topic', 'cfDet', 'memberPay', 'couponGoods', 'order_all', 'refund_list'];
  // 只有商品详情、聚合页、专题等能单独支持分享的页面能设置 并且是第一次访问的时候才能设置 (即没有上一级路由)
  if (originPage.some(f => f === nowPageName) && !lastPageName) {
    const {
      from = '', propa = '', propb = '', ssid = '', entry = '',
    } = origin.$route.query;
    const getFrom = function () {
      if (from) {
        store.commit('homePage/changeFrom', from);
        if (from === 'jifen_shop_home') {
          DataStorage.setStorage('jifen_shop_home', true, 'sessionStorage');
        }
        if (from === 'jubaopen_shop_home') {
          DataStorage.setStorage('jubaopen_shop_home', true, 'sessionStorage');
        }
        return from;
      } else if (Env.isWeixin) {
        return 'weixin';
      } else if (Env.isWeiBo) {
        return 'weibo';
      } else if (Env.isQQ) {
        return 'qq';
      } else if (Env.isAndroid || Env.isIOS) {
        return 'phone_h5';
      }
      return 'pc_h5';
    };
    const { did, imei = '', idfa = '' } = await getUid();
    const obj = {
      uid: did,
      imei,
      idfa,
      ssid: ssid || guid(),
      from: getFrom(),
      propa,
      propb,
      entry,
    };
    DataStorage.setFixedUploadParams(obj);
  }
}

export function getCommonParams() {
  const page = DataStorage.getNowPage();
  const pre_page = DataStorage.getPrePage();
  const ts = new Date().getTime();
  const fixed_params = DataStorage.getFixedUploadParams();
  let fixedVal = {
    uid: '',
    ssid: '',
    from: '',
    propa: '',
    propb: '',
    entry: '',
  };
  if (fixed_params) {
    fixedVal = fixed_params;
  }
  const { ticket: vid } = getMgtvUserTicket();
  return {
    vid,
    page,
    pre_page,
    ts,
    ...fixedVal,
  };
}

/* 进入上报 */
export function uploadAccessData(val) {
  let gid = null;
  let orderid = null;
  let gsize_num = null;
  if (val) {
    gid = val.gid || null;
    orderid = val.orderid || null;
    gsize_num = val.gsize_num || null;
  }
  const common_params = getCommonParams();
  const { page } = common_params;
  const req = {
    log_type: 'access',
    ...common_params,
  };
  const needGid = ['goods_detail', 'order_detail', 'pay', 'goods_comments'].some(f => f === page); // 是否需要上传商品id
  const needOrderid = ['order_detail'].some(f => f === page); // 是否需要上传订单id
  const needGsize = ['order_detail', 'pay'].some(f => f === page); // 是否需要上传商品id_规格id_数量
  if (needGid) {
    req.gid = gid;
  }
  if (needOrderid) {
    req.orderid = orderid;
  }
  if (needGsize) {
    req.gsize_num = gsize_num;
  }
  setTimeout(() => {
    uploadRequest(req);
  }, 100);
}


/* 记录页面浏览时长上报 */
export function uploadCloseData(val) {
  let gid = null;
  if (val) {
    gid = val.gid || null;
  }
  const nowTime = () => new Date().getTime();
  const common_params = getCommonParams();
  const { page } = common_params;
  const needGid = ['goods_detail', 'goods_comments'].some(f => f === page); // 是否需要上传商品id
  const visitLogData = DataStorage.getPageVisitiLog(page);
  let reqData = null;
  if (visitLogData) {
    const { hasAnyAction, startVisitTime } = visitLogData;
    const vtime = nowTime() - Number(startVisitTime);
    reqData = {
      log_type: 'close',
      vtime,
      has_action: Number(hasAnyAction),
      ...common_params,
    };
    if (needGid) {
      reqData.gid = gid;
    }
    uploadRequest(reqData);
  }
}

/* 该方法为用户主动点击页内元素 发起的跳转  所以跳转之前 设置has_action为1 */
export function beforeRouteChange(params, obj) {
  const { goodsId = null } = obj;
  DataStorage.setPageVisitiLog(true);
  obj.hasRouteChange = true;
  uploadCloseData({ gid: goodsId });
  if (params) {
    obj.$router.push(params);
  }
}


export function uploadAddCart({ gid = null, gsize_num = null }) {
  const common_params = getCommonParams();
  const reqData = {
    gid,
    gsize_num,
    log_type: 'add_car',
    ...common_params,
  };
  uploadRequest(reqData);
}

export function uploadDeleteCart({ gid = null, gsize_num = null }) {
  const common_params = getCommonParams();
  const reqData = {
    gid,
    gsize_num,
    log_type: 'remove_car',
    ...common_params,
  };
  uploadRequest(reqData);
}

export function uploadSubmitOrder({
  gid = null, gsize_num = null, orderid = null, origfrom_size = null, price = 0,
}) {
  const common_params = getCommonParams();
  const reqData = {
    gid,
    gsize_num,
    orderid,
    origfrom_size,
    price: aesEncrypt(price), // 价格 加密
    log_type: 'submit_order',
    ...common_params,
  };
  uploadRequest(reqData);
}


export function uploadPayWay({
  gid = null,
  gsize_num = null,
  orderid = null,
  origfrom_size = null,
  price = 0,
  paytype = null,
}) {
  const common_params = getCommonParams();
  const reqData = {
    gid,
    gsize_num,
    orderid,
    origfrom_size,
    paytype,
    price: aesEncrypt(price), // 价格 加密
    log_type: 'select_paytype',
    ...common_params,
  };
  uploadRequest(reqData);
}

export async function uploadPaySuccess({
  gid = null,
  gsize_num = null,
  orderid = null,
  origfrom_size = null,
  price = 0,
  final_price = 0,
}) {
  if (sessionStorage.getItem(`lingxi_order_${orderid}`)) {
    return;
  }
  const common_params = await getCommonParams();
  const reqData = {
    gid,
    gsize_num,
    orderid,
    origfrom_size,
    final_price: aesEncrypt(final_price),
    price: aesEncrypt(price), // 价格 加密
    log_type: 'pay_complete',
    ...common_params,
  };
  sessionStorage.setItem(`lingxi_order_${orderid}`, 1);
  uploadRequest(reqData);
}

export function getGoodsSizeNum(arr, needPrice) {
  const goodsIds = [];
  const goodsSkuNum = [];
  const origins = [];
  const price = []; // 每个商品的价格
  const obj = {};
  arr.forEach(({
    goodsId, specKey, goodsNum, fromOrigin, goodsPrice,
  }) => {
    if (!obj[goodsId]) {
      obj[goodsId] = true;
      goodsIds.push(goodsId);
    }
    if (needPrice === 'needPrice' && goodsPrice && goodsNum) {
      price.push((goodsPrice * goodsNum).toFixed(2));
    }
    const key = specKey ? specKey.replace(/_/g, '-') : 0;
    goodsSkuNum.push(`${goodsId}_${key}_${goodsNum}`);
    if (fromOrigin) {
      origins.push(fromOrigin);
    }
  });
  return {
    gid: goodsIds.join(), gsize_num: goodsSkuNum.join(), origfrom_size: origins.join(), final_price: price.join(),
  };
}

// web关闭上报
export function h5CloseUpload() {
  /* 微信分享进来会先刷新一次页面 (reload，因为处理#的问题)  为防止进入就用上报关闭参数 延迟处理 */
  setTimeout(() => {
    window.onbeforeunload = () => {
      uploadCloseData();
    };
    window.onunload = () => {
      uploadCloseData();
    };
    window.onpagehide = () => {
      uploadCloseData();
    };
  }, 2000);
}

/* 初始化关闭上报 */
export function initCloseUpload() {
  if (Env.isMgtvApp) {
    MgtvApi.registerhandler('closeWebView', {}, () => {
      uploadCloseData();
    });
  } else {
    h5CloseUpload();
  }
}


export function getDevicePlatForm() {
  if (MgtvApi.isAphone) {
    return '2';
  }
  if (MgtvApi.isIpad) {
    return '11';
  }
  return '1';
}

